import {
  ProdProtocolKeyService,
  ProtocolKey,
  StaticMarket,
  isProdProtocolKey,
  makeAddressSync,
  protocolKeys,
} from "@silo/types";
import { Effect, pipe } from "effect";
import { match } from "ts-pattern";
import { GraphClient } from "../graph-client";
import { BlobClient } from "../blob-client";

const localStaticMarkets: StaticMarket[] = [
  {
    protocolKey: "local",
    marketAddress: makeAddressSync(
      "0x266B82aB8C9a46B0D79De216Fb13e48b2Ee87a86"
    ),
    isDeprecated: false,
    rawSymbol: "WBTC",
    lastTvlUsd: null,
  },
  {
    protocolKey: "local",
    marketAddress: makeAddressSync(
      "0x2d387653bA1aca235680A21fDc5a32b4c3A79d09"
    ),
    isDeprecated: false,
    rawSymbol: "CRV",
    lastTvlUsd: null,
  },
];

export type UpdateStaticMarkets = ReturnType<typeof updateStaticMarkets>;
export type UpdateStaticMarketsSuccess =
  Effect.Effect.Success<UpdateStaticMarkets>;
export type UpdateStaticMarketsError = Effect.Effect.Error<UpdateStaticMarkets>;
export type UpdateStaticMarketsContext =
  Effect.Effect.Context<UpdateStaticMarkets>;

/**
 * Should run once an hour to update the static markets
 */
export function updateStaticMarkets() {
  return Effect.gen(function* () {
    yield* Effect.all(
      protocolKeys.map((protocolKey) =>
        updateProtocolStaticMarkets(protocolKey)
      ),
      { concurrency: "unbounded" }
    );
  }).pipe(Effect.withLogSpan("elapsed"));
}

export type UpdateProtocolStaticMarkets = ReturnType<
  typeof updateProtocolStaticMarkets
>;
export type UpdateProtocolStaticMarketsSuccess =
  Effect.Effect.Success<UpdateProtocolStaticMarkets>;
export type UpdateProtocolStaticMarketsError =
  Effect.Effect.Error<UpdateProtocolStaticMarkets>;
export type UpdateProtocolStaticMarketsContext =
  Effect.Effect.Context<UpdateProtocolStaticMarkets>;

export function updateProtocolStaticMarkets(protocolKey: ProtocolKey) {
  return Effect.gen(function* () {
    const staticMarkets = yield* match(protocolKey)
      .when(isProdProtocolKey, (key) =>
        pipe(
          GraphClient.getStaticMarkets(),
          Effect.provideService(ProdProtocolKeyService, key)
        )
      )
      .with("local", () => Effect.succeed(localStaticMarkets))
      .with("anvil", () => Effect.succeed([]))
      .exhaustive();

    yield* BlobClient.setProtocolStaticMarkets(protocolKey, staticMarkets);
  }).pipe(Effect.annotateLogs("protocol", protocolKey));
}
